import { BarChart3, TrendingUp, TrendingDown } from "lucide-react";

const dashboardScoreCards = [
  {
    id: 1,
    title: "All Leads",
    score: 277,
    isIncreasing: true,
    color: "bg-blue-500",
  },
  {
    id: 2,
    title: "Call Back",
    score: 19,
    isIncreasing: true,
    color: "bg-purple-400",
  },
  {
    id: 3,
    title: "Closed/Not-Closed",
    score: 24,
    isIncreasing: false,
    color: "bg-purple-600",
  },
  {
    id: 4,
    title: "Enrolled",
    score: 42,
    isIncreasing: true,
    color: "bg-green-600",
  },
  {
    id: 5,
    title: "Failed",
    score: 32,
    isIncreasing: false,
    color: "bg-red-600",
  },
];

export default function DashboardScore() {
  return (
    <div className="my-3 grid grid-cols-6 gap-4">
      {dashboardScoreCards.map(({ id, title, score, isIncreasing, color }) => (
        <div
          key={id}
          className="relative bg-white border border-gray-100 shadow-md rounded-lg h-[90px] p-3"
        >
          <div
            className={`absolute top-3 left-3 ${color} p-1 rounded-sm text-white`}
          >
            <BarChart3 className="w-5 h-5" />
          </div>
          <span
            className={`absolute top-3 right-3 ${
              isIncreasing ? "bg-green-100" : "bg-red-100"
            } p-1 flex items-center gap-1 text-[12px] rounded-sm`}
          >
            {isIncreasing ? (
              <>
                <TrendingUp className="text-green-600 w-4 h-4" />
                <span className="text-green-900 font-medium">+12%</span>
              </>
            ) : (
              <>
                <TrendingDown className="text-red-600 w-4 h-4" />
                <span className="text-red-900 font-medium">-12%</span>
              </>
            )}
          </span>

          <div className="absolute bottom-3 left-3 right-3 flex justify-between items-center">
            <h1 className="text-[13px] text-gray-500">{title}</h1>
            <h1 className="text-[16px] text-gray-800">{score}</h1>
          </div>
        </div>
      ))}
    </div>
  );
}
